import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ResourcesService } from 'app/services/resources.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TermsComponent implements OnInit, OnDestroy {
  termsData = [];
  tCImage: 'https://cdn.sanity.io/images/jizm7zxy/production/1a237ab87d39c29cda3b3aa12b94c34325a05607-1920x1054.png?fm=webp&q=75';
  private _unsubscribeAll: Subject<any>;

  constructor(private resourcesService: ResourcesService) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  private init(): void {
    this.resourcesService.onTermsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((data) => {
      if (data !== null && data.length > 0) {
        this.termsData = data;
      } else {
        this.termsData = undefined;
      }
    });
    this.resourcesService.getTerms();
  }
}
